export const apiConfigs = {
    hostUrl: process.env.REACT_APP_API_URL,
    hostUrlV2: process.env.REACT_APP_API_URL_V2,
  }
